import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';
import getFormattedValues, { formatReceived } from 'utils/formatValues';

export const baseURI = '/empresas/ventas-de-alcoholes/';

/**
 * GET Alcohols
 * @param {Object} params
 * @returns {Promise<Array<Object>>}
 */
export const getVendedoresDeAlcoholes = async (params = null) => {
  try {
    const response = await API.get(baseURI, { params });
    const output = { ...response.data, results: formatReceived(response.data.results) };
    return output;
  } catch (err) {
    onError(err);
    return { results: [] };
  }
};

/**
 * GET Alcohol
 * @param {number} id
 * @returns {Promise<Object>}
 */
export const getVendedorDeAlcoholes = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return null;
  }
};

/**
 * POST Alcohol
  * @param {Object} values
 * @returns {Promise<Object>}
 */
export const postVendedorDeAlcoholes = async (values) => {
  try {
    const response = await API.post(baseURI, getFormattedValues(values));
    onSuccess(response, 'Agregado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Alcohol
 * @param {number} id
 * @param {Object} values
 * @returns {Promise<Object>}
 */
export const patchVendedorDeAlcoholes = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, getFormattedValues(values));
    onSuccess(response, 'Editado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Alcohol
 * @param {number} id
 * @returns {Promise<Object>}
 */
export const deleteVendedorDeAlcoholes = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 *  GET Horarios Alcohol
 * @param {number} id
 * @returns Promise<Array<Object>>
 */
export const getHorariosVendedorDeAlcoholes = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}/horarios/`);
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Alcohol para la caja
 * @param {object} params
 * @returns {Promise<Array<Object>>}
 */
export const getVendedorDeAlcoholesCaja = async (params = null) => {
  try {
    const response = await API.get('/empresas/venta-de-alcohol-caja/', { params });
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return [];
  }
};
